import { RecordStatus } from "../../enums";
import { IModelBase } from "./IModelBase";

export class ViewModelBase implements IModelBase {
  RecordStatus: RecordStatus = RecordStatus.NoChange;

  RowVersion?: string;
}
